import React, { useState } from 'react';
import styled from 'styled-components';
import calculateImg from "../assets/images/calculate.png"

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 30px 0px;
  padding: 20px;
  font-family: 'Arial', sans-serif;
  gap: 20px;

   @media (max-width: 768px) {
    margin-top: 0px;
    padding:0px;
  }
`;

const Container = styled.div`
    flex: 1;
    min-width: 50%;
    background: #f5f8fc;
    padding: 20px;
    border: 1px solid #d1e3f3;
    border-radius: 8px;

    @media (max-width: 768px) {
    padding:5px;
  }
`;

const ResultsPanel = styled.div`
  flex: 1;
  min-width: 300px;
  background: #f5f8fc;
  padding: 20px;
  border: 1px solid #d1e3f3;
  border-radius: 8px;
  @media (max-width: 768px) {
    padding:5px;
  }
`;

const Title = styled.h2`
  text-align: center;
  background: #000;
  color: white;
  padding: 10px;
  border-radius: 6px 6px 0 0;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    margin-top:0px;
  }
`;

const FormGroup = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

const Radio = styled.input`
  margin-right: 10px;
`;

const Label = styled.label`
  flex: 1;
  font-weight: bold;
`;

const Input = styled.input`
  flex: 2;
  padding: 8px;
  border: 1px solid ${props => (props.requiredHighlight ? 'red' : '#ccc')};
  border-radius: 5px;
`;

const PeriodInputWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex: 2;
`;

const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 20px;
`;

const Button = styled.button`
  padding: 10px 20px;
  border: 2px solid #fff;
  background: white;
  color: #fff;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  margin: 1%;
  width: 48%;

  &:hover {
    background: #000;
    color: white;
  }

  @media (max-width: 768px) {
     padding: 10px;
  }
`;

const ResultItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  font-size:20px;
`;

// const EMICalculator = () => {
//   const [selected, setSelected] = useState('emi');
//   const [loanAmount, setLoanAmount] = useState('');
//   const [interest, setInterest] = useState('');
//   const [years, setYears] = useState('');
//   const [months, setMonths] = useState('');
//   const [emi, setEmi] = useState('');
//   const [calculateValues, setCalculateValues]= useState(false);
//   const [processingFeePercent, setProcessingFeePercent] = useState('');


//   const [results, setResults] = useState({
//     emi: '',
//     totalInterest: '',
//     totalPayment: '',
//     processingFee: '',
//     feePercent: ''
//   });

//   const reset = () => {
//     setLoanAmount('');
//     setInterest('');
//     setYears('');
//     setMonths('');
//     setEmi('');
//     setSelected('emi');
//     setResults({
//       emi: '',
//       totalInterest: '',
//       totalPayment: '',
//       processingFee: '',
//     });
//   };

//   const calculate = () => {
//     const P = parseFloat(loanAmount);
//     const R = parseFloat(interest) / 12 / 100;
//     const N = parseFloat(years) * 12 + parseFloat(months ? months : 0);
//     const emiValue = parseFloat(emi);

//     if (selected === 'loan') {
//       if (!interest || !years || !emi) {
//         alert('Please fill Interest, Period and EMI to calculate Loan Amount.');
//         return;
//       }
//       const loan = emiValue * ((1 - Math.pow(1 + R, -N)) / R);
//       setLoanAmount(loan.toFixed(2));
//     }

//     if (selected === 'interest') {
//       if (!loanAmount || !years || !emi) {
//         alert('Please fill Loan Amount, Period and EMI to calculate Interest.');
//         return;
//       }

//       let low = 0,
//         high = 100,
//         guess;
//       for (let i = 0; i < 100; i++) {
//         guess = (low + high) / 2;
//         const monthlyRate = guess / 12 / 100;
//         const calculatedEmi =
//           P * monthlyRate * Math.pow(1 + monthlyRate, N) /
//           (Math.pow(1 + monthlyRate, N) - 1);
//         if (calculatedEmi > emiValue) {
//           high = guess;
//         } else {
//           low = guess;
//         }
//       }
//       setInterest(guess.toFixed(2));
//     }

//     if (selected === 'period') {
//       if (!loanAmount || !interest || !emi) {
//         alert('Please fill Loan Amount, Interest, and EMI to calculate Period.');
//         return;
//       }

//       let monthsResult = 0;
//       let balance = P;
//       while (balance > 0 && monthsResult < 600) {
//         const interestPortion = balance * R;
//         const principalPortion = emiValue - interestPortion;
//         balance -= principalPortion;
//         monthsResult++;
//       }
//       setYears(Math.floor(monthsResult / 12));
//       setMonths(monthsResult % 12);
//     }

//     if (selected === 'emi') {
//       if (!loanAmount || !interest || !years) {
//         alert('Please fill Loan Amount, Interest, and Period to calculate EMI.');
//         return;
//       }
//       const calculatedEmi =
//         P * R * Math.pow(1 + R, N) / (Math.pow(1 + R, N) - 1);
//       setEmi(calculatedEmi.toFixed(2));
//     }

//     // Always update result section if possible
//     if (loanAmount && interest && years) {
//       const calculatedEmi =
//         P * R * Math.pow(1 + R, N) / (Math.pow(1 + R, N) - 1);
//       const totalPayment = calculatedEmi * N;
//       const totalInterest = totalPayment - P;
//       const feePercent = parseFloat(processingFeePercent) || 0;
//       const processingFee = P * (feePercent / 100);
//       setCalculateValues(true);
//       setResults({
//         emi: calculatedEmi.toFixed(2),
//         totalInterest: totalInterest.toFixed(2),
//         totalPayment: totalPayment.toFixed(2),
//         processingFee: processingFee.toFixed(2),
//         feePercent: feePercent.toFixed(2)
//       });
//     }
//   };

//   const isRequired = (field) => selected !== field;

//   return (
//     <Wrapper>
//       <Container>
//         <Title>What do you want to calculate?</Title>

//         <FormGroup>
//           <div style={{width:"35%"}}>
//             <Radio
//             type="radio"
//               name="option"
//               checked={selected === 'loan'}
//               onChange={() => setSelected('loan')}
//             />
//             <Label>Amount</Label>
//           </div>
//           <Input
//             type="number"
//             disabled={selected === 'loan'}
//             value={loanAmount}
//             onChange={(e) => setLoanAmount(e.target.value)}
//             requiredHighlight={isRequired('loan') && !loanAmount}
//           />
//         </FormGroup>

//         <FormGroup>
//           <div style={{width:"35%"}}>
//           <Radio
//             type="radio"
//             name="option"
//             checked={selected === 'interest'}
//             onChange={() => setSelected('interest')}
//           />
//           <Label>Interest %</Label>
//           </div>
//           <Input
//             type="number"
//             disabled={selected === 'interest'}
//             value={interest}
//             onChange={(e) => setInterest(e.target.value)}
//             requiredHighlight={isRequired('interest') && !interest}
//           />
//         </FormGroup>

//         <FormGroup>
//           <div style={{width:"35%"}}>
//           <Radio
//             type="radio"
//             name="option"
//             checked={selected === 'period'}
//             onChange={() => setSelected('period')}
//           />
//           <Label>Period</Label>
//           </div>
//           <PeriodInputWrapper>
//             <Input
//               style={{width:"100%"}}
//               type="number"
//               placeholder="Years"
//               disabled={selected === 'period'}
//               value={years}
//               onChange={(e) => setYears(e.target.value)}
//               requiredHighlight={isRequired('period') && !years}
//             />
//             <Input
//             style={{width:"100%"}}
//               type="number"
//               placeholder="Months"
//               disabled={selected === 'period'}
//               value={months}
//               onChange={(e) => setMonths(e.target.value)}
//               // requiredHighlight={isRequired('period') && !months}
//             />
//           </PeriodInputWrapper>
//         </FormGroup>

//         <FormGroup>
//           <div style={{width:"35%"}}>
//           <Radio
//             type="radio"
//             name="option"
//             checked={selected === 'emi'}
//             onChange={() => setSelected('emi')}
//           />
//           <Label>EMI</Label>
//           </div>
//           <Input
//             type="number"
//             disabled={selected === 'emi'}
//             value={emi}
//             onChange={(e) => setEmi(e.target.value)}
//             requiredHighlight={isRequired('emi') && !emi}
//           />
//         </FormGroup>

//         <FormGroup>
//         <div style={{ width: "35%" }}>
//           <Label>Processing Fee %</Label>
//         </div>
//         <Input
//           type="number"
//           placeholder="Enter %"
//           value={processingFeePercent}
//           onChange={(e) => setProcessingFeePercent(e.target.value)}
//         />
//       </FormGroup>

//         <ButtonWrapper>
//            <div style={{width:"35%"}}></div>
//            <div style={{width:"65%"}}>
//             <Button style={{background:"#008000"}} onClick={calculate}>Calculate</Button>
//             <Button style={{background:"#ff0000"}} onClick={reset}>Reset</Button>
//            </div>
//         </ButtonWrapper>
//       </Container>

//       <ResultsPanel>
//         {console.log("calculateValues", calculateValues)}
//         {
//           calculateValues ? <>
//           <Title>How much will it cost?</Title>
//         <ResultItem>
//           <span>Monthly EMI</span>
//           <span>₹ {results.emi}</span>
//         </ResultItem>
//         <ResultItem>
//           <span>Total Interest</span>
//           <span>₹ {results.totalInterest}</span>
//         </ResultItem>
//         <ResultItem>
//           <span>Processing Fee ({processingFeePercent ? processingFeePercent : 0}%)</span>
//           <span>₹ {results.processingFee}</span>
//         </ResultItem>
//         <ResultItem bold>
//           <span>Total Payment</span>
//           <span>₹ {results.totalPayment}</span>
//         </ResultItem>
//           </> : <img style={{width:"100%", height:"100%"}} src={calculateImg}/>
//         }
        
//       </ResultsPanel>
//     </Wrapper>
//   );
// };

// export default EMICalculator;

// import React, { useState } from 'react';
// import your styled components like Wrapper, Container, Title, etc.

const INR_TO_AED = 1 / 22.5;

const EMICalculator = () => {
  const [selected, setSelected] = useState('emi');
  const [loanAmount, setLoanAmount] = useState('');
  const [interest, setInterest] = useState('');
  const [years, setYears] = useState('');
  const [months, setMonths] = useState('');
  const [emi, setEmi] = useState('');
  const [calculateValues, setCalculateValues] = useState(false);
  const [processingFeePercent, setProcessingFeePercent] = useState('');

  const [results, setResults] = useState({
    emi: '',
    totalInterest: '',
    totalPayment: '',
    processingFee: '',
    feePercent: ''
  });

  const reset = () => {
    setLoanAmount('');
    setInterest('');
    setYears('');
    setMonths('');
    setEmi('');
    setSelected('emi');
    setProcessingFeePercent('');
    setCalculateValues(false);
    setResults({
      emi: '',
      totalInterest: '',
      totalPayment: '',
      processingFee: '',
      feePercent: ''
    });
  };

  const calculate = () => {
    const P = parseFloat(loanAmount);
    const R = parseFloat(interest) / 12 / 100;
    const N = parseFloat(years) * 12 + parseFloat(months || 0);
    const emiValue = parseFloat(emi);

    if (selected === 'loan') {
      if (!interest || !years || !emi) {
        alert('Please fill Interest, Period and EMI to calculate Loan Amount.');
        return;
      }
      const loan = emiValue * ((1 - Math.pow(1 + R, -N)) / R);
      setLoanAmount(loan.toFixed(2));
    }

    if (selected === 'interest') {
      if (!loanAmount || !years || !emi) {
        alert('Please fill Loan Amount, Period and EMI to calculate Interest.');
        return;
      }

      let low = 0,
        high = 100,
        guess;
      for (let i = 0; i < 100; i++) {
        guess = (low + high) / 2;
        const monthlyRate = guess / 12 / 100;
        const calculatedEmi =
          P * monthlyRate * Math.pow(1 + monthlyRate, N) /
          (Math.pow(1 + monthlyRate, N) - 1);
        if (calculatedEmi > emiValue) {
          high = guess;
        } else {
          low = guess;
        }
      }
      setInterest(guess.toFixed(2));
    }

    if (selected === 'period') {
      if (!loanAmount || !interest || !emi) {
        alert('Please fill Loan Amount, Interest, and EMI to calculate Period.');
        return;
      }

      let monthsResult = 0;
      let balance = P;
      while (balance > 0 && monthsResult < 600) {
        const interestPortion = balance * R;
        const principalPortion = emiValue - interestPortion;
        balance -= principalPortion;
        monthsResult++;
      }
      setYears(Math.floor(monthsResult / 12));
      setMonths(monthsResult % 12);
    }

    if (selected === 'emi') {
      if (!loanAmount || !interest || !years) {
        alert('Please fill Loan Amount, Interest, and Period to calculate EMI.');
        return;
      }
      const calculatedEmi =
        P * R * Math.pow(1 + R, N) / (Math.pow(1 + R, N) - 1);
      setEmi(calculatedEmi.toFixed(2));
    }

    // Always update result section if possible
    if (loanAmount && interest && years) {
      const calculatedEmi =
        P * R * Math.pow(1 + R, N) / (Math.pow(1 + R, N) - 1);
      const totalPayment = calculatedEmi * N;
      const totalInterest = totalPayment - P;
      const feePercent = parseFloat(processingFeePercent) || 0;
      const processingFee = P * (feePercent / 100);
      setCalculateValues(true);
      setResults({
        emi: (calculatedEmi * INR_TO_AED).toFixed(2),
        totalInterest: (totalInterest * INR_TO_AED).toFixed(2),
        totalPayment: ((totalPayment + processingFee) * INR_TO_AED).toFixed(2),
        processingFee: (processingFee * INR_TO_AED).toFixed(2),
        feePercent: feePercent.toFixed(2)
      });
    }
  };

  const isRequired = (field) => selected !== field;

  return (
    <Wrapper>
      <Container>
        <Title>What do you want to calculate?</Title>

        <FormGroup>
          <div style={{ width: "35%" }}>
            <Radio
              type="radio"
              name="option"
              checked={selected === 'loan'}
              onChange={() => setSelected('loan')}
            />
            <Label>Amount</Label>
          </div>
          <Input
            type="number"
            disabled={selected === 'loan'}
            value={loanAmount}
            onChange={(e) => setLoanAmount(e.target.value)}
            requiredHighlight={isRequired('loan') && !loanAmount}
          />
        </FormGroup>

        <FormGroup>
          <div style={{ width: "35%" }}>
            <Radio
              type="radio"
              name="option"
              checked={selected === 'interest'}
              onChange={() => setSelected('interest')}
            />
            <Label>Interest %</Label>
          </div>
          <Input
            type="number"
            disabled={selected === 'interest'}
            value={interest}
            onChange={(e) => setInterest(e.target.value)}
            requiredHighlight={isRequired('interest') && !interest}
          />
        </FormGroup>

        <FormGroup>
          <div style={{ width: "35%" }}>
            <Radio
              type="radio"
              name="option"
              checked={selected === 'period'}
              onChange={() => setSelected('period')}
            />
            <Label>Period</Label>
          </div>
          <PeriodInputWrapper>
            <Input
              style={{ width: "100%" }}
              type="number"
              placeholder="Years"
              disabled={selected === 'period'}
              value={years}
              onChange={(e) => setYears(e.target.value)}
              requiredHighlight={isRequired('period') && !years}
            />
            <Input
              style={{ width: "100%" }}
              type="number"
              placeholder="Months"
              disabled={selected === 'period'}
              value={months}
              onChange={(e) => setMonths(e.target.value)}
            />
          </PeriodInputWrapper>
        </FormGroup>

        <FormGroup>
          <div style={{ width: "35%" }}>
            <Radio
              type="radio"
              name="option"
              checked={selected === 'emi'}
              onChange={() => setSelected('emi')}
            />
            <Label>EMI</Label>
          </div>
          <Input
            type="number"
            disabled={selected === 'emi'}
            value={emi}
            onChange={(e) => setEmi(e.target.value)}
            requiredHighlight={isRequired('emi') && !emi}
          />
        </FormGroup>

        <FormGroup>
          <div style={{ width: "35%" }}>
            <Label>Processing Fee %</Label>
          </div>
          <Input
            type="number"
            placeholder="Enter %"
            value={processingFeePercent}
            onChange={(e) => setProcessingFeePercent(e.target.value)}
          />
        </FormGroup>

        <ButtonWrapper>
          <div style={{ width: "35%" }}></div>
          <div style={{ width: "65%" }}>
            <Button style={{ background: "#008000" }} onClick={calculate}>Calculate</Button>
            <Button style={{ background: "#ff0000" }} onClick={reset}>Reset</Button>
          </div>
        </ButtonWrapper>
      </Container>

      <ResultsPanel>
        {
          calculateValues ? (
            <>
              <Title>How much will it cost?</Title>
              <ResultItem>
                <span>Monthly EMI</span>
                <span>د.إ {results.emi}</span>
              </ResultItem>
              <ResultItem>
                <span>Total Interest</span>
                <span>د.إ {results.totalInterest}</span>
              </ResultItem>
              <ResultItem>
                <span>Processing Fee ({processingFeePercent ? processingFeePercent : 0}%)</span>
                <span>د.إ {results.processingFee}</span>
              </ResultItem>
              <ResultItem bold>
                <span>Total Payment</span>
                <span>د.إ {results.totalPayment}</span>
              </ResultItem>
            </>
          ) : (
            <img style={{ width: "100%", height: "100%" }} src={calculateImg} />
          )
        }
      </ResultsPanel>
    </Wrapper>
  );
};

export default EMICalculator;
